module.exports = __webpack_public_path__ + "img/sellTxt.88146995.png";